// extracted by mini-css-extract-plugin
export default {"deletebutton":"deletebutton_deletebutton__-4ahs"};